'use client';
// Debug logging: set to true to inspect AI model responses locally
const debug = false;
import { smartFetch } from '../foundation/smartfetch';
import { buildUrl } from '../foundation/urlbuilder';
/**
 * Service for integrating with Google Gemini API for SEO recommendations
 */
export class GeminiApiService {
    apiKey;
    baseUrl;
    constructor(apiKey, baseUrl = 'https://generativelanguage.googleapis.com') {
        this.apiKey = apiKey;
        this.baseUrl = baseUrl;
    }
    /**
   * Generate SEO recommendations for a route
   */
    async generateRouteRecommendations(request) {
        try {
            // Use the proxy API route instead of direct Google API call
            const data = await smartFetch('/api/ai/recommendations', {
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(request)
                }
            });
            if (!data.success) {
                throw new Error(data.error || 'AI API request failed');
            }
            return {
                success: true,
                data: data.data
            };
        }
        catch (error) {
            console.error('AI API error:', error);
            return {
                success: false,
                error: error instanceof Error ? error.message : 'Unknown error occurred'
            };
        }
    }
    /**
   * List available models to debug API issues
   */
    async listModels() {
        try {
            const url = buildUrl({
                baseUrl: this.baseUrl,
                pathSegments: ['v1', 'models'],
                params: { key: this.apiKey },
            });
            const data = await smartFetch(url, {
                requestInit: {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            });
            if (debug)
                console.log('Available models:', data);
            return data;
        }
        catch (error) {
            console.error('Error listing models:', error);
            return null;
        }
    }
}
/**
 * Create a Gemini API service instance
 */
export function createGeminiApiService(apiKey) {
    return new GeminiApiService(apiKey);
}
